export default __webpack_public_path__ + "static/media/t1-p1-img3.238c0368.png";